import React, { useState } from "react";
import useCollapse from "react-collapsed";
import Button from "../Button/Button";
import styles from "./CollapseContent.module.less";

export interface Props {
    enabled?: boolean;
    children: React.ReactNode;
}

export default function CollapseContent(props: Props): JSX.Element {
    const [isOpen, setOpen] = useState(false);
    const { getCollapseProps, getToggleProps } = useCollapse({ isOpen, collapsedHeight: 115 });

    if (!props.enabled) {
        return <>{props.children}</>;
    }

    return (
        <>
            <div className={styles["CollapseContent-content"]} {...getCollapseProps()}>
                {props.children}
            </div>

            <Button
                className={styles["CollapseContent-btn"]}
                theme="grey"
                {...getToggleProps({
                    onClick: () => setOpen(oldOpen => !oldOpen)
                })}
            >
                {!isOpen ? "More +" : "Less -"}
            </Button>
        </>
    );
}
